export default __webpack_public_path__ + "static/media/image2.0ed010f6.svg";